//TODO: replace with ht.toggleClasses hardToggle
//twistys close all
$('body').on('click', '.twistClose', function () {
  $('dl.twisty > dt:not(.lite), dl.twisty > dd').addClass('twistClosed');
  return false;
});
